import classNames from 'classnames';
import React from 'react';

import { remap } from '../utils';
import { ProgressBarTooltip } from './ProgressBarTooltip';

export interface ProgressBarProps {
  variant: 'warning' | 'info';
  now?: number;
  tooltipText: string;
  className?: string;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  now = 0,
  variant,
  tooltipText,
  className = '',
}) => {
  const progress = Math.min(now, 100);
  const tooltipXPosition = remap(progress, [0, 100], [-2, 102]); // tooltipXPosition is between -2% and 102%
  const triangleXPosition = remap(progress, [0, 100], [0, 70]); // triangleXPosition is between 0% and 70%

  return (
    <div className={classNames('oejr-progress-bar-wrapper', className)}>
      <ProgressBarTooltip
        text={tooltipText}
        style={{ left: `${tooltipXPosition}%`, transform: `translateX(${-progress}%)` }}
        triangleStyle={{ left: `${triangleXPosition}%` }}
      />
      <div className={classNames('oejr-progress', variant && `oejr-progress-${variant}`)}>
        <div className="oejr-progress-bar" style={{ width: progress + '%' }} />
      </div>
    </div>
  );
};
